module.exports = __webpack_public_path__ + "static/media/BSPLogoNew01.0a6109f1.png";